export default __webpack_public_path__ + "static/media/anonMentalHealth.b88adc03.png";